import { useContext } from 'react';
import { ThemeContext } from '../contexts/ThemeContext';

/**
 * Custom hook to access theme context
 *
 * @returns {Object} Theme context value
 * @throws {Error} If used outside ThemeProvider
 *
 * @example
 * const { activeTheme, switchTheme, canEditTheme } = useTheme();
 *
 * // Use theme colors
 * <div style={{ backgroundColor: activeTheme.colors.background.primary }}>
 *
 * // Switch theme
 * switchTheme('light');
 */
export function useTheme() {
  const context = useContext(ThemeContext);

  if (context === undefined) {
    throw new Error('useTheme must be used within a ThemeProvider');
  }

  return context;
}

export default useTheme;
